import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Loader, Checkbox, Button } from 'sputnik-ui'
import { Card } from 'components'
import { ListItem, ListItemText, CardActions } from '@material-ui/core'
import LocationCityIcon from '@material-ui/icons/LocationCity'
import { useTranslation } from 'react-i18next'
import {
  getAdminAddressAccess,
  destroyAdminAddressAccess,
} from 'store/operations'

const AddressAccessList = ({
  addressAccesses,
  err,
  dispatch,
  selectedCompany,
  ...props
}) => {
  const { t } = useTranslation('geo')
  const [selectedAddressAccesses, setSelectedAddressAccesses] = useState([])
  const handleDelete = () => {
    dispatch(
      destroyAdminAddressAccess({
        company_uuid: selectedCompany,
        address_uuids: selectedAddressAccesses,
      })
    )
  }
  const handleAddressAccessChange = (value) => () => {
    const currentIndex = selectedAddressAccesses.indexOf(value)
    const newSelected = [...selectedAddressAccesses]

    if (currentIndex === -1) {
      newSelected.push(value)
    } else {
      newSelected.splice(currentIndex, 1)
    }

    setSelectedAddressAccesses(newSelected)
  }

  useEffect(() => {
    if (selectedCompany) {
      dispatch(getAdminAddressAccess({ company_uuid: selectedCompany }))
    }
  }, [dispatch, selectedCompany])

  return (
    <Card
      title={t('address_access:list')}
      titleIcon={<LocationCityIcon />}
      {...props}
    >
      <CardActions>
        <Button
          disabled={selectedAddressAccesses.length === 0}
          size="small"
          type="submit"
          onClick={handleDelete}
        >
          {t('address_access:delete_all')}
        </Button>
      </CardActions>
      {addressAccesses ? (
        addressAccesses.map((address) => (
          <ListItem key={address.address_uuid}>
            <Checkbox
              onClick={handleAddressAccessChange(address.address_uuid)}
              checked={selectedAddressAccesses.includes(address.address_uuid)}
              color="blue"
              style={{
                margin: '0px',
                padding: '0px',
                marginRight: 16,
              }}
            />

            <ListItemText
              primary={address.human_address}
              secondary={`${address.human_address_kind} | ${address.address_uuid}`}
            />
          </ListItem>
        ))
      ) : (
        <Loader
          msg={t('address_access:loaders.choose_company')}
          err={err}
          fluid
        />
      )}
    </Card>
  )
}

const mapStateToProps = ({ resourcesAdminAddressAccess }) => ({
  addressAccesses: resourcesAdminAddressAccess.list,
  err: resourcesAdminAddressAccess.err,
})

export default connect(mapStateToProps)(AddressAccessList)
